var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68815 1.95712C5.68881 3.82665 5.68947 5.69221 5.69013 7.55381C5.69013 7.70047 5.65281 7.82533 5.57816 7.92838L4.07197 5.81773L0.00623889 0.0506014C0.00215949 0.0450998 -2.95609e-05 0.0384231 3.01519e-07 0.0315742C3.01639e-05 0.0247252 0.00227799 0.0180671 0.00640521 0.0126014C0.0105324 0.00713558 0.0163161 0.00315268 0.0228953 0.00124913C0.0294744 -0.000654416 0.0364942 -0.000376156 0.0429023 0.00204143L5.68815 1.95712Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57819 7.92841C5.65284 7.82535 5.69016 7.7005 5.69016 7.55384C5.6895 5.69224 5.68884 3.82668 5.68818 1.95715L6.75936 1.58357L11.166 0.064497C11.2974 0.0189149 11.3229 0.0529392 11.2423 0.166564C9.40973 2.74889 7.5587 5.35203 5.68917 7.97597C5.66935 8.00372 5.63236 7.98786 5.57819 7.92841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.42d0d31a94a1293abf39d7be253652e5.svg";
export { ForwardRef as ReactComponent };